import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { PalletStockGateway } from 'src/app/application/gateway/PalletStockGateway';
import { StockColumnRuleGateway } from 'src/app/application/gateway/StockColumnRuleGateway';
import { PalletStock, PalletStockFilterRequest, Stock, StockColumn } from 'src/app/domain/models/PalletStock';
import { CreateStockColumnRuleRequest, StockColumnRule } from 'src/app/domain/models/StockColumnRule';
import { ErrorMessageUtil } from '../../util/error-message-util';

@Component({
  selector: 'app-stock-column-rule',
  templateUrl: './stock-column-rule.component.html',
  styleUrls: ['./stock-column-rule.component.css']
})
export class StockColumnRuleComponent implements OnInit, OnChanges {

  usedColumn: StockColumn[] = [];
  notUsedColumn: StockColumn[] = [];
  palletStock: PalletStock[] = [];
  rules: StockColumnRule[] = [];
  rulesToCreated: StockColumnRule[] = []

  @Input()
  stock:Stock | undefined
  // inicializa request paginado con 500 en size
  request: PalletStockFilterRequest = {
    pageSize: 500,
    pageNumber:1,
    stockId: 0,
    containerFilter: [],
    speciesSizeFilter: [],
    statusFilter: [],
    growerFilter: [],
    speciesFilter:[],
    varietyFilter: [],
    programNameFilter:[]

  }

    columnsFormGroup: FormGroup = this._formBuilder.group({
      stockColumnId: [null, Validators.required],
      destinationColumnId: [null, Validators.required],
      divisorCharacter: [''],
      changeOrigin: new FormControl<boolean>(false)
    })


  loading: boolean = false;

  constructor(private _router: Router,
    private _messageService: MessageService,
    private _stockColumnRuleService: StockColumnRuleGateway,
    public translate: TranslateService,
    private _palletStockService: PalletStockGateway,
    private _formBuilder: FormBuilder
  ){

  }

  ngOnInit(): void {
    this.setUpView()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['stock'])
    {
      this.setUpView()
    }
  }

  setUpView()
  {
    this.getPalletStock()
    this.getRules()
    this.getUnUsedColumns()
    this.getColumnsByStock()
    this.rulesToCreated = []
    this.columnsFormGroup.reset();
  }

  getPalletStock()
  {
    if(this.stock){
      this.loading = true;
      this.request.stockId = this.stock.id;
      this._palletStockService.getPalletStockPaged(this.request).subscribe({
        next: (v) => {
            this.palletStock = v.items;
            this.loading = false;
        },
        error: (e) => {
            this.loading = false
            this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.PalletStock.GetPalletStockError') })
        }
      })
    }
  }

  getRules()
  {
    if(this.stock)
    {
      this.loading = true;
      this._stockColumnRuleService.getRulesByStockId(this.stock.id).subscribe({
        next: (v) => {
          this.rules = v;
          this.loading = false;
        },
        error: (e) => {
          this.loading = false;
          this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant(
            ErrorMessageUtil.getResponseError(e,
              "",
            'MessageService.StockColumnRule.GetRulesError' ))
            })
        }
      })

    }
  }

  getUnUsedColumns()
  {
    if(this.stock)
    {
      this.loading = true
      this._palletStockService.getUnUsedStockColumnRule(this.stock.id).subscribe({
        next: (v) => {
          this.notUsedColumn = v;
          this.loading = false;
        },
        error: (e) => {
          this.loading = false;
          this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant(
            ErrorMessageUtil.getResponseError(e,
              "",
            'MessageService.StockColumnRule.GetUnUsedColumns' ))
            })
        }
      })
    }
  }

  getColumnsByStock()
  {
    if(this.stock)
    {
      this._palletStockService.getStockFormatColumns(this.stock.id).subscribe({
        next: (v) => {
          this.usedColumn = v;
          this.loading = false;
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.PalletStock.GetStockColumnsError') })
        }
      })
    }
  }

  createRules()
  {
    if(this.stock)
    {
      this.addRule()
      var request: CreateStockColumnRuleRequest = {
        stockId: this.stock.id,
        StockColumnRuleList: this.rulesToCreated
      }

      this._stockColumnRuleService.create(request).subscribe({
        next: (v) => {
          this.loading = false;
          this._messageService.add({ severity: 'success',
          summary: this.translate.instant('MessageService.Summary.SuccessAction'),
          detail: this.translate.instant('MessageService.StockColumnRule.CreateRuleSuccess')
          })
          this.setUpView()
        },
        error: (e) => {
          this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant(
            ErrorMessageUtil.getResponseError(e,
              "",
            'MessageService.StockColumnRule.CreateRuleError' ))
            })
        }
      })
    }
  }

  addRule()
  {
    if(this.stock && this.columnsFormGroup.valid)
    {
      var formValue = this.columnsFormGroup.value
      this.rulesToCreated.push({
        ...formValue,
        changeOrigin: formValue.changeOrigin ?? false
      })
    }
  }

  removeRule(ruleId: number)
  {
    this.loading = true;
    this._stockColumnRuleService.delete(ruleId).subscribe({
      next: (v) => {
        this.loading = false;
        this._messageService.add({ severity: 'success',
        summary: this.translate.instant('MessageService.Summary.SuccessAction'),
        detail: this.translate.instant('MessageService.StockColumnRule.DeleteRuleSuccess')
        })
        this.setUpView()
      },
      error: (e) => {
        this.loading = false;
        this._messageService.add({ severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant(
        ErrorMessageUtil.getResponseError(e,
          "",
        'MessageService.StockColumnRule.DeleteRuleError' ))
        })
      }
    })
  }

  applyRules()
  {
    if(this.stock)
    {
      this.loading = true;
      this._palletStockService.updatePalletStockWithRules(this.stock.id).subscribe({
        next: (v) => {
          this.loading = false;
          this._messageService.add({ severity: 'success',
          summary: this.translate.instant('MessageService.Summary.SuccessAction'),
          detail: this.translate.instant('MessageService.StockColumnRule.ApplyRuleSuccess')
          })
          this.setUpView()
        },
        error: (e) => {
          this.loading = false;
          this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant(
          ErrorMessageUtil.getResponseError(e,
            "",
          'MessageService.StockColumnRule.ApplyRuleError' ))
          })
        }
      })
    }
  }
}
